<div class="countryDetailsContainer" id="countryDetailsContainer">
  <div class="header-container">
    <div class="left-container">
      <div class="flag-container">
        <img src="{{ 'assets/icons/flags/' + countryName + '.png'  }}" />
      </div>
      <h1>{{ ('countries.' + (countryNameID - 1) | translate).name }}</h1>
    </div>

    <div class="close-button" (click)="closePopupDetails()">
      <nb-icon icon="cross" pack="icomoon"></nb-icon>
    </div>
  </div>
  <div class="data-container">
    <div class="single-line" *ngFor="let label of detailsLabels">
      <div class="property-label">
        <h4>{{ label.translations | translate }}</h4>
      </div>
      <div class="data">
        <h3>
          <div
            class="change-factor neutral"
            [ngClass]="{'bigger' : earningsPercentChange > 0, 'smaller' : earningsPercentChange < 0, 'neutral' : earningsPercentChange == 0}"
            *ngIf="compareMode && label.name === 'earnings'">
            <nb-icon icon="arrow-up" pack="icomoon" class="icon-up"></nb-icon>
            <span> <span *ngIf="earningsPercentChange > 0">+</span> {{ earningsPercentChange.toFixed(1) }} %</span>
          </div>
          <div
            class="change-factor neutral"
            [ngClass]="{'bigger' : visitsPercentChange > 0, 'smaller' : visitsPercentChange < 0, 'neutral' : visitsPercentChange == 0}"
            *ngIf="compareMode && label.name === 'visits'">
            <nb-icon icon="arrow-up" pack="icomoon" class="icon-up"></nb-icon>
            <span> <span *ngIf="visitsPercentChange > 0">+</span> {{ visitsPercentChange.toFixed(1) }} %</span>
          </div>
          <div
            class="change-factor neutral"
            [ngClass]="{'bigger' : leadsPercentChange > 0, 'smaller' : leadsPercentChange < 0, 'neutral' : leadsPercentChange == 0}"
            *ngIf="compareMode && label.name === 'leads'">
            <nb-icon icon="arrow-up" pack="icomoon" class="icon-up"></nb-icon>
            <span> <span *ngIf="leadsPercentChange > 0">+</span> {{ leadsPercentChange.toFixed(1) }} %</span>
          </div>
          <div
            class="change-factor neutral"
            [ngClass]="{'bigger' : conversionPercentChange > 0, 'smaller' : conversionPercentChange < 0, 'neutral' : conversionPercentChange == 0}"
            *ngIf="compareMode && label.name === 'conversion'">
            <nb-icon icon="arrow-up" pack="icomoon" class="icon-up"></nb-icon>
            <span> <span *ngIf="conversionPercentChange > 0">+</span> {{ conversionPercentChange.toFixed(1) }} %</span>
          </div>
          {{ selectedCountry ? selectedCountry[label.name] : '-' }}{{ label.name === 'conversion' ? '%' : '' }}
          <span class="currency">{{ label.name === 'earnings' ? selectedCountry?.currency : '' }}</span>
        </h3>
        <h3 *ngIf="compareMode" class="compare">
          {{ selectedCompareCountry ? selectedCompareCountry[label.name] : '-' }}{{ label.name === 'conversion' ? '%' : '' }}
          <span class="currency">{{ label.name === 'earnings' ? selectedCountry?.currency : '' }}</span>
        </h3>
      </div>
    </div>
  </div>
  <app-tertiary-button *ngIf="compareMode" class="tertiary-custom" [text]="'check_details'" [icon]="''" [iconSize]="20" (emitAction)="redirectToCountries()">
  </app-tertiary-button>
</div>
